var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding-top":"100px"}},[(_vm.audioSrc)?_c('audio-player',{attrs:{"src":_vm.audioSrc}}):_vm._e(),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }